"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[518],{

/***/ 60518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ two_paragraphs_paragraph_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/two-paragraphs-paragraph-component.scss.js



var HORIZONTAL_MARGIN = constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING;
var HORIZONTAL_MARGIN_STRING = "".concat(HORIZONTAL_MARGIN, "px");
var BORDER_RADIUS = 16;
var BORDER_RADIUS_STRING = "".concat(BORDER_RADIUS, "px");
var StyledTwoParagraphsParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e81w97u0"
})("max-width:", "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px"), ";margin:auto;.side-by-side-text-and-asset{border-radius:", BORDER_RADIUS_STRING, ";margin-left:", HORIZONTAL_MARGIN_STRING, ";margin-right:", HORIZONTAL_MARGIN_STRING, ";.side-by-side-content{border-radius:", BORDER_RADIUS_STRING, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/two-paragraphs-paragraph-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var TwoParagraphsParagraphComponent = function(props) {
    var primaryParagraph = props.primaryParagraph, secondaryParagraph = props.secondaryParagraph, alignToLogo = props.alignToLogo, primaryParagraphAdvancedProps = props.primaryParagraphAdvancedProps, secondaryParagraphAdvancedProps = props.secondaryParagraphAdvancedProps, restProps = _object_without_properties(props, [
        "primaryParagraph",
        "secondaryParagraph",
        "alignToLogo",
        "primaryParagraphAdvancedProps",
        "secondaryParagraphAdvancedProps"
    ]);
    console.log(primaryParagraph);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwoParagraphsParagraphComponent, {
        className: classnames_default()("two-paragraphs-paragraph-component", {
            "align-to-logo": alignToLogo
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread({
            fullParagraph: _object_spread({}, primaryParagraph),
            replaceAssetComponent: full_paragraph/* default */.ZP,
            replaceAssetComponentProps: _object_spread({}, secondaryParagraph, secondaryParagraphAdvancedProps),
            asset: {
                position: props.paragraphVerticalAlignment
            },
            alignToLogo: alignToLogo
        }, restProps, primaryParagraphAdvancedProps))
    });
};
/* harmony default export */ var two_paragraphs_paragraph_component = (TwoParagraphsParagraphComponent);


/***/ })

}]);